import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { VIEW, EDIT, YES, ACTIVE } from "const"
import {
    StoreType,
    setCcLibrarySetBaseRoute,
    moduleIds,
} from "client/store"
import {
    projectsRoute,
    projectBaseRoute,
    ccComplianceSetsRoute,
    ccCompliantItemsRoute,
} from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"
import SetList from "./setList"
import SetView from "./setView"
import SetEdit from "./setEdit"
import ItemView from "./itemView"
import ItemEdit from "./itemEdit"

const CcLibrary = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const dispatch = useDispatch()

    const { ccModuleAccess } = packageSettings
    const moduleAccess = ccModuleAccess === YES && moduleList[moduleIds.cc].status === ACTIVE
    const access = userData.accountId === 1 || moduleAccess

    const baseRouteMask = project.id ? `${projectBaseRoute}${ccComplianceSetsRoute}` : ccComplianceSetsRoute
    const baseRoute = project.id ? `${projectsRoute}/${VIEW}/${project.id}${ccComplianceSetsRoute}` : ccComplianceSetsRoute

    useEffect(() => {
        dispatch(setCcLibrarySetBaseRoute(baseRoute))
    }, [])

    if (!access) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${baseRouteMask}/${VIEW}/:setId${ccCompliantItemsRoute}/${VIEW}/:itemId`}
                component={ItemView}
            />
            <Route
                path={`${baseRouteMask}/${VIEW}/:setId${ccCompliantItemsRoute}/${EDIT}/:itemId`}
                component={ItemEdit}
            />
            <Route
                path={`${baseRouteMask}/${VIEW}/:setId`}
                component={SetView}
            />
            <Route
                path={`${baseRouteMask}/${EDIT}/:setId`}
                component={SetEdit}
            />
            <Route
                path={baseRouteMask}
                component={SetList}
            />
        </Switch>
    )
}
export default CcLibrary
